var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2862,
    height: 2862,
    viewBox: "0 0 2862 2862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M951.196 2228C716.919 2228 527 2037.81 527 1803.2L527 1272.2C527 920.284 811.879 635 1163.29 635L1698.5 635C2049.91 635 2334.79 920.284 2334.79 1272.2L2334.79 1768.12C2334.79 1790.9 2342.11 1813.08 2355.66 1831.38L2518.94 2058.54C2570.84 2128.62 2520.89 2228 2433.76 2228L951.196 2228Z",
    fill: "url(#paint0_linear_6255_487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877 1589.8C877 1707.55 972.139 1803 1089.5 1803L1302 1803L1302 1589.8L1302 1483.2C1302 1365.45 1206.86 1270 1089.5 1270C972.139 1270 877 1365.45 877 1483.2L877 1589.8Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1472 1272.29L1472 1590.71L1472 1803L1684.5 1803C1801.86 1803 1897 1707.96 1897 1590.71L1897 1272.29C1897 1155.04 1801.86 1060 1684.5 1060C1567.14 1060 1472 1155.04 1472 1272.29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6255_487",
    x1: 1533.5,
    y1: 635,
    x2: 1533.5,
    y2: 2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A122DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7647FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/AILogo.3ad9512bd7e8f4d3d7bac25a2392c03a.svg";
export { ForwardRef as ReactComponent };